// src/pages/PortalSaaS/modules/VisitorPaywall.js
import React from 'react';
import { useAuth } from '../../../context/AuthContext';

const VisitorPaywall = ({ onStartOnboarding }) => {
    const { currentUser } = useAuth();
    
    // DETECÇÃO DE PERSONA: Varredura avançada cobrindo padrão Global (.edu/.ac), Federais (uf..), Institutos (if..), Universidades (un..) e Elite Privada/Militar. Blinda contra subdomínios (ex: @alunos.ufsc.br).
    const isAcademicEmail = currentUser?.email?.match(/@.*(\.(edu|ac)(\.[a-z]{2})?$|[\.\@](uf[a-z]{1,5}|if[a-z]{1,5}|un[a-z]{2,7}|puc[a-z]*|usp|fgv|mackenzie|insper|espm|ita|ime|fatec[a-z]*|senai|senac)\.br$)/i);

    return (
        <div className="pts-fade-in" style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center', paddingTop: '20px' }}>
            <div style={{ display: 'inline-block', background: isAcademicEmail ? '#dcfce7' : '#e0f2fe', color: isAcademicEmail ? '#16a34a' : '#0369a1', padding: '6px 16px', borderRadius: '50px', fontWeight: 'bold', fontSize: '0.8rem', marginBottom: '20px' }}>
                {isAcademicEmail ? '👩‍🎓 AMBIENTE ACADÊMICO DETECTADO' : '🏢 AMBIENTE CORPORATIVO PRÉ-CONFIGURADO'}
            </div>
            
            <h1 style={{ fontSize: '2.5rem', color: '#0f172a', marginBottom: '15px', fontWeight: '800' }}>
                Bem-vindo à Era da Engenharia Digital
            </h1>
            
            <p style={{ fontSize: '1.1rem', color: '#64748b', marginBottom: '40px', lineHeight: '1.6', padding: '0 20px' }}>
                Seu acesso foi autenticado ({currentUser?.email}). Para desbloquear a <strong>Mesa Técnica da IA</strong> e a central de cálculos, ative sua assinatura.
            </p>

            {/* CARDS DE VALOR ADAPTADOS POR PERSONA */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '40px', textAlign: 'left' }}>
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', padding: '25px', borderRadius: '16px', boxShadow: '0 10px 20px rgba(0,0,0,0.02)' }}>
                    <div style={{ fontSize: '2rem', marginBottom: '15px' }}>🧠</div>
                    <h3 style={{ fontSize: '1.1rem', color: '#0f172a', margin: '0 0 10px 0' }}>Mesa Técnica IA</h3>
                    <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>
                        {isAcademicEmail 
                            ? 'Debata normas do DNIT e tire dúvidas teóricas complexas com agentes especialistas em geotecnia.' 
                            : 'Agentes especialistas deliberam sobre seus traços e otimizam custos de materiais em tempo real.'}
                    </p>
                </div>
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', padding: '25px', borderRadius: '16px', boxShadow: '0 10px 20px rgba(0,0,0,0.02)' }}>
                    <div style={{ fontSize: '2rem', marginBottom: '15px' }}>📑</div>
                    <h3 style={{ fontSize: '1.1rem', color: '#0f172a', margin: '0 0 10px 0' }}>
                        {isAcademicEmail ? 'Simulação de Ensaios' : 'Laudos em Segundos'}
                    </h3>
                    <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>
                        {isAcademicEmail 
                            ? 'Aprenda a aplicar teoria VECD, Módulo Dinâmico e Reologia em casos práticos com supervisão da IA.' 
                            : 'Cálculos complexos auditados e transformados em PDFs timbrados automaticamente.'}
                    </p>
                </div>
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', padding: '25px', borderRadius: '16px', boxShadow: '0 10px 20px rgba(0,0,0,0.02)' }}>
                    <div style={{ fontSize: '2rem', marginBottom: '15px' }}>{isAcademicEmail ? '🎓' : '🛡️'}</div>
                    <h3 style={{ fontSize: '1.1rem', color: '#0f172a', margin: '0 0 10px 0' }}>
                        {isAcademicEmail ? 'Licença Restrita' : 'Segurança Forense'}
                    </h3>
                    <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>
                        {isAcademicEmail 
                            ? 'Conta protegida. Geração de relatórios PDF desabilitada para garantir uso exclusivamente focado em pesquisa.' 
                            : 'Adequação automática às últimas atualizações das normas DNIT e mitigação de erros humanos.'}
                    </p>
                </div>
            </div>

            {/* CHECKOUT BOX ADAPTADO */}
            <div style={{ background: '#f8fafc', border: `1px solid ${isAcademicEmail ? '#86efac' : '#e2e8f0'}`, padding: '30px', borderRadius: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'left' }}>
                <div>
                    <h2 style={{ fontSize: '1.8rem', color: isAcademicEmail ? '#16a34a' : '#0f172a', margin: '0 0 5px 0' }}>
                        {isAcademicEmail ? 'R$ 49,90' : 'R$ 499,00'} <span style={{ fontSize: '1rem', color: '#64748b', fontWeight: '500' }}>/mês</span>
                    </h2>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
                        {isAcademicEmail 
                            ? 'Desconto educacional aplicado. Acesso individual focado em pesquisa e estudos.' 
                            : 'Ativação corporativa (Matriz + 1 Licença de Sócio-Proprietário inclusa).'}
                    </p>
                </div>
                <button 
                    onClick={onStartOnboarding} 
                    className="pts-btn-launch"
                    style={{ width: 'auto', padding: '16px 32px', margin: 0, background: isAcademicEmail ? '#16a34a' : '#0f172a' }}
                >
                    {isAcademicEmail ? 'INICIAR ASSINATURA ACADÊMICA' : 'CONFIGURAR LABORATÓRIO E ASSINAR'}
                </button>
            </div>
        </div>
    );
};

export default VisitorPaywall;